module.exports = __webpack_public_path__ + "static/media/extreme_events.e73d158a.jpg";